/**
 * qrz
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering */

export class OnlineBookingApi {
    protected basePath = 'https://localhost:44364';
    public defaultHeaders : any = {};

    static $inject: string[] = ['$http', '$httpParamSerializer', 'basePath'];

    constructor(protected $http: ng.IHttpService, protected $httpParamSerializer?: (d: any) => any, basePath?: string) {
        if (basePath !== undefined) {
            this.basePath = basePath;
        }
    }

    /**
     * 
     * @param shopId 
     */
    public onlineBookingEnumUnitTypeGroupByShopId (shopId: number, extraHttpRequestParams?: any ) : ng.IHttpPromise<Array<models.UnitTypeGroup>> {
        const localVarPath = this.basePath + '/api/OnlineBooking/EnumUnitTypeGroupByShopId';

        let queryParameters: any = {};
        let headerParams: any = (<any>Object).assign({}, this.defaultHeaders);
        // verify required parameter 'shopId' is not null or undefined
        if (shopId === null || shopId === undefined) {
            throw new Error('Required parameter shopId was null or undefined when calling onlineBookingEnumUnitTypeGroupByShopId.');
        }

        if (shopId !== undefined) {
            queryParameters['shopId'] = shopId;
        }

        let httpRequestParams: ng.IRequestConfig = {
            method: 'GET',
            url: localVarPath,
            params: queryParameters,
            headers: headerParams
        };

        if (extraHttpRequestParams) {
            httpRequestParams = (<any>Object).assign(httpRequestParams, extraHttpRequestParams);
        }

        return this.$http(httpRequestParams);
    }
    /**
     * 
     * @param shopId 
     * @param iid 
     */
    public onlineBookingFindByItemId (shopId: number, iid: string, extraHttpRequestParams?: any ) : ng.IHttpPromise<models.UnitInfo> {
        const localVarPath = this.basePath + '/api/OnlineBooking/FindByItemId';

        let queryParameters: any = {};
        let headerParams: any = (<any>Object).assign({}, this.defaultHeaders);
        // verify required parameter 'shopId' is not null or undefined
        if (shopId === null || shopId === undefined) {
            throw new Error('Required parameter shopId was null or undefined when calling onlineBookingFindByItemId.');
        }

        // verify required parameter 'iid' is not null or undefined
        if (iid === null || iid === undefined) {
            throw new Error('Required parameter iid was null or undefined when calling onlineBookingFindByItemId.');
        }

        if (shopId !== undefined) {
            queryParameters['shopId'] = shopId;
        }

        if (iid !== undefined) {
            queryParameters['iid'] = iid;
        }

        let httpRequestParams: ng.IRequestConfig = {
            method: 'GET',
            url: localVarPath,
            params: queryParameters,
            headers: headerParams
        };

        if (extraHttpRequestParams) {
            httpRequestParams = (<any>Object).assign(httpRequestParams, extraHttpRequestParams);
        }

        return this.$http(httpRequestParams);
    }
    /**
     * 
     * @param shopId 
     * @param searchText 
     */
    public onlineBookingFindByRoomNumber (shopId: number, searchText: string, extraHttpRequestParams?: any ) : ng.IHttpPromise<models.UnitInfo> {
        const localVarPath = this.basePath + '/api/OnlineBooking/FindByRoomNumber';

        let queryParameters: any = {};
        let headerParams: any = (<any>Object).assign({}, this.defaultHeaders);
        // verify required parameter 'shopId' is not null or undefined
        if (shopId === null || shopId === undefined) {
            throw new Error('Required parameter shopId was null or undefined when calling onlineBookingFindByRoomNumber.');
        }

        // verify required parameter 'searchText' is not null or undefined
        if (searchText === null || searchText === undefined) {
            throw new Error('Required parameter searchText was null or undefined when calling onlineBookingFindByRoomNumber.');
        }

        if (shopId !== undefined) {
            queryParameters['shopId'] = shopId;
        }

        if (searchText !== undefined) {
            queryParameters['searchText'] = searchText;
        }

        let httpRequestParams: ng.IRequestConfig = {
            method: 'GET',
            url: localVarPath,
            params: queryParameters,
            headers: headerParams
        };

        if (extraHttpRequestParams) {
            httpRequestParams = (<any>Object).assign(httpRequestParams, extraHttpRequestParams);
        }

        return this.$http(httpRequestParams);
    }
    /**
     * 
     * @param fileName 
     */
    public onlineBookingGetBlobInfo (fileName: string, extraHttpRequestParams?: any ) : ng.IHttpPromise<models.BlobInfo> {
        const localVarPath = this.basePath + '/api/OnlineBooking/GetBlobInfo';

        let queryParameters: any = {};
        let headerParams: any = (<any>Object).assign({}, this.defaultHeaders);
        // verify required parameter 'fileName' is not null or undefined
        if (fileName === null || fileName === undefined) {
            throw new Error('Required parameter fileName was null or undefined when calling onlineBookingGetBlobInfo.');
        }

        if (fileName !== undefined) {
            queryParameters['fileName'] = fileName;
        }

        let httpRequestParams: ng.IRequestConfig = {
            method: 'GET',
            url: localVarPath,
            params: queryParameters,
            headers: headerParams
        };

        if (extraHttpRequestParams) {
            httpRequestParams = (<any>Object).assign(httpRequestParams, extraHttpRequestParams);
        }

        return this.$http(httpRequestParams);
    }
    /**
     * 
     * @param cmsShopId 
     * @param currentActivityKey 
     */
    public onlineBookingGetBookingTimeStatus (cmsShopId: number, currentActivityKey?: string, extraHttpRequestParams?: any ) : ng.IHttpPromise<models.BookedTimeStatus> {
        const localVarPath = this.basePath + '/api/OnlineBooking/GetBookingTimeStatus';

        let queryParameters: any = {};
        let headerParams: any = (<any>Object).assign({}, this.defaultHeaders);
        // verify required parameter 'cmsShopId' is not null or undefined
        if (cmsShopId === null || cmsShopId === undefined) {
            throw new Error('Required parameter cmsShopId was null or undefined when calling onlineBookingGetBookingTimeStatus.');
        }

        if (cmsShopId !== undefined) {
            queryParameters['cmsShopId'] = cmsShopId;
        }

        if (currentActivityKey !== undefined) {
            queryParameters['currentActivityKey'] = currentActivityKey;
        }

        let httpRequestParams: ng.IRequestConfig = {
            method: 'GET',
            url: localVarPath,
            params: queryParameters,
            headers: headerParams
        };

        if (extraHttpRequestParams) {
            httpRequestParams = (<any>Object).assign(httpRequestParams, extraHttpRequestParams);
        }

        return this.$http(httpRequestParams);
    }
    /**
     * 
     */
    public onlineBookingGetMaster (extraHttpRequestParams?: any ) : ng.IHttpPromise<models.OnlineBookingMaster> {
        const localVarPath = this.basePath + '/api/OnlineBooking/GetMaster';

        let queryParameters: any = {};
        let headerParams: any = (<any>Object).assign({}, this.defaultHeaders);
        let httpRequestParams: ng.IRequestConfig = {
            method: 'GET',
            url: localVarPath,
            params: queryParameters,
            headers: headerParams
        };

        if (extraHttpRequestParams) {
            httpRequestParams = (<any>Object).assign(httpRequestParams, extraHttpRequestParams);
        }

        return this.$http(httpRequestParams);
    }
    /**
     * 
     * @param arg 
     */
    public onlineBookingPayment (arg: models.PaymentRequest, extraHttpRequestParams?: any ) : ng.IHttpPromise<models.PaymentResponce> {
        const localVarPath = this.basePath + '/api/OnlineSignUp/Payment';

        let queryParameters: any = {};
        let headerParams: any = (<any>Object).assign({}, this.defaultHeaders);
        // verify required parameter 'arg' is not null or undefined
        if (arg === null || arg === undefined) {
            throw new Error('Required parameter arg was null or undefined when calling onlineBookingPayment.');
        }

        let httpRequestParams: ng.IRequestConfig = {
            method: 'POST',
            url: localVarPath,
            data: arg,
            params: queryParameters,
            headers: headerParams
        };

        if (extraHttpRequestParams) {
            httpRequestParams = (<any>Object).assign(httpRequestParams, extraHttpRequestParams);
        }

        return this.$http(httpRequestParams);
    }
    /**
     * 
     * @param zip 
     */
    public onlineBookingZipToAddress (zip: string, extraHttpRequestParams?: any ) : ng.IHttpPromise<models.ZipToAddressResponce> {
        const localVarPath = this.basePath + '/api/OnlineSignUp/ZipToAddress';

        let queryParameters: any = {};
        let headerParams: any = (<any>Object).assign({}, this.defaultHeaders);
        // verify required parameter 'zip' is not null or undefined
        if (zip === null || zip === undefined) {
            throw new Error('Required parameter zip was null or undefined when calling onlineBookingZipToAddress.');
        }

        if (zip !== undefined) {
            queryParameters['zip'] = zip;
        }

        let httpRequestParams: ng.IRequestConfig = {
            method: 'GET',
            url: localVarPath,
            params: queryParameters,
            headers: headerParams
        };

        if (extraHttpRequestParams) {
            httpRequestParams = (<any>Object).assign(httpRequestParams, extraHttpRequestParams);
        }

        return this.$http(httpRequestParams);
    }
}
